const polyfill = (() => {
  let clock = Date.now();

  return callback => {
    const currentTime = Date.now();

    if (currentTime - clock > 16) {
      clock = currentTime;
      return callback(currentTime);
    }
    setTimeout(() => polyfill(callback), 0);
    return undefined;
  };
})();

const requestAnimationFrame =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  polyfill;

function makeLinksOpenOnTop(iframe) {
  const doc = iframe.contentWindow.document;
  const body = doc.body;

  const isHREFValid = href => {
    const cleanHREF = href.trim();

    return cleanHREF !== '' && !cleanHREF.startsWith('javascript') && !cleanHREF.endsWith('#');
  };
  [...body.querySelectorAll('a')]
    .filter(link => isHREFValid(link.getAttribute('href')))
    .filter(link => !link.getAttribute('target'))
    .forEach(link => link.setAttribute('target', '_top'));
}

export default function iframeResizer(iframeToResize) {
  function resizeIframe(iframe, callback) {
    const doc = iframe.contentWindow.document;
    const body = doc.body;

    const height = Math.max(body.offsetHeight, body.clientHeight);

    iframe.height = `${height}px`; // eslint-disable-line no-param-reassign

    requestAnimationFrame(callback);
  }

  const syncResize = () => resizeIframe(iframeToResize, syncResize);

  requestAnimationFrame(syncResize);
  makeLinksOpenOnTop(iframeToResize);
}
